import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const UnavailabilityTooltip = ({ periods }) => {
    if (!periods || periods.length === 0) {
        return null;
    }

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('ru-RU');
    };

    const renderTooltip = (props) => (
        <Tooltip id="unavailability-tooltip" {...props}>
            <div className="text-start">
                <strong>Недоступен:</strong>
                {periods.map(period => (
                    <div key={period.id}>
                        {formatDate(period.start_date)} - {formatDate(period.end_date)}
                    </div>
                ))}
            </div>
        </Tooltip>
    );

    return (
        <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip}
        >
            <span className="ms-2 text-muted">
                <i className="fas fa-calendar-times"></i>
            </span>
        </OverlayTrigger>
    );
};

export default UnavailabilityTooltip;
